// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import {
  openNavigationDrawer,
  closeNavigationDrawer,
  openMiniBag,
  closeMiniBag,
  setCondensedStatus,
  openAccountDrawer,
  closeAccountDrawer,
} from '@tcp/core/src/components/common/organisms/Header/container/Header.actions';
import { showNavigationFooter } from '@tcp/core/src/components/features/content/Navigation/container/Navigation.actions';
import { setTrackOrderModalMountedState } from '@tcp/core/src/components/features/account/TrackOrder/container/TrackOrder.actions';
import {
  openOverlayModal,
  closeOverlayModal,
} from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.actions';
import { setActiveWishlistAction } from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import { loginModalOpenState } from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.selectors';
import { getOpenState } from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.selectors';
import {
  getIsChangeRecalForEcom,
  getIsCSHEnabled,
  getIsShowNavAnimation,
  getIsRedesignedPdpDesktopView,
  getIsExtendedDisplay,
  getIsSlpDesktopView,
  getIsNewNavigationImagesEnabled,
  getABTestIsSearchEnhancementRedesignEnabled,
  getIsShopThisStoreEnabled,
  getIsHamburgerMenuRedesignEnabled,
  getIsGuestFavEnabled,
  getConfirmationPageHeaderAndButton,
  getIsSnjPjpBrandDisabled,
  getIsShowBagSimplifiedHeader,
  getIsHeaderScrollViewDisabled,
  getIsDrawerTransitionEnabled,
  getIsStickyHeaderBgColorEnabled,
  getIsRedesignGlobalHeaderEnabled,
  getIsSearchBarAlignmentEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getIsGuest,
  isPlccUser,
  isRememberedUser,
  getUserName,
  getUserLoggedInState,
  getCurrentPointsState,
  getTotalRewardsState,
  getDefaultFavStore,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import BAGPAGE_SELECTORS, {
  getECOMStatus,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import {
  getEnableFullPageAuth,
  getMinibagOnHoverEnabled,
} from '@tcp/web/src/components/features/content/HomePage/HomePage.selectors';
import { getIsPickupModalOpen } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  getModalState,
  getIsKeepMinibagCloseQV,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getCartItemCount } from '@tcp/core/src/utils/cookie.util';
import { setCurrentStoreInfo } from '@tcp/core/src/components/features/storeLocator/StoreDetail/container/StoreDetail.actions';
import { getBrandInCaps, isAndroidWeb } from '@tcp/core/src/utils';
import {
  getIsCartItemsSFL,
  getIsMiniBagOpen,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import {
  closeQuickViewModal,
  updateMiniBagCloseStatusQV,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { closePickupModal } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import { setLoginModalMountedState } from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.actions';
import {
  isOpenAddedToBag,
  getIsKeepMinibagClose,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import { updateMiniBagCloseStatus } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { getTrackOrderMountedState } from '@tcp/core/src/components/features/account/TrackOrder/container/TrackOrder.selectors';
import { selectOrder } from '@tcp/core/src/components/features/account/CustomerHelp/container/CustomerHelp.actions';
import { mergeAccountReset } from '@tcp/core/src/components/features/account/CustomerHelp/organisms/MergeAccounts/container/MergeAccounts.actions';
import { resetEmailConfirmationRequest } from '@tcp/core/src/components/features/account/CustomerHelp/organisms/EmailConfirmation/container/EmailConfirmation.action';
import {
  selectDefaultWishlistId,
  selectWishListCount,
  wishListFromState,
  selectActiveWishList,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.selectors';

import { HEADER_LONGER_BRAND_IDS } from '@tcp/core/src/constants/brandSpecific.constants';
import { getShowShopThisStoreNotification } from '@tcp/core/src/components/features/browse/ShopThisStore/container/ShopThisStore.selectors';
import { getConvertedBossUnavailableList } from '@tcp/core/src/components/features/CnC/CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.selector';

import getCheckNavImagesFlag, { getAccountDrawerOpen } from './Header.selector';
import HeaderWrapper from './HeaderWrapper';
import { showShopThisStoreNotifications } from '../molecules/HeaderShopThisStoreAreaCondensed/container/HeaderShopThiStoreAreaCondensed.actions';
import { filterBrandTabs } from '../utils/HeaderNew.util';

const mapStateToProps = (state, ownProps) => {
  const { Header } = state;
  const { router } = ownProps;
  const isRedesignedPdpDesktopView = getIsRedesignedPdpDesktopView(state);
  const isExtendedDisplay = getIsExtendedDisplay(state);
  const isSLPExtendedView = getIsSlpDesktopView(state);
  const isExtendedPage =
    (router?.asPath.match(/\/p\//g) && isRedesignedPdpDesktopView) ||
    (router?.asPath.match(/\/search\//g) && isSLPExtendedView) ||
    (router?.asPath.match(/\/c\//g) && isExtendedDisplay);
  const brandId = HEADER_LONGER_BRAND_IDS[getBrandInCaps()];
  let { brandTabs: updatedBrandTabs } = Header;
  const isSnjPjpBrandDisabled = getIsSnjPjpBrandDisabled(state);
  if (isSnjPjpBrandDisabled) {
    updatedBrandTabs = filterBrandTabs(updatedBrandTabs);
  }

  return {
    loyaltyPromoBanner: Header.loyaltyPromoBanner,
    brandTabs: JSON.stringify(updatedBrandTabs),
    topPromoBanner: Header.topPromoBanner,
    promoMessageWrapper: Header.promoMessageWrapper,
    headerPromoTextArea: Header.promoTextBannerCarousel,
    headerPromoHtmlArea: Header.promoHtmlBannerCarousel,
    composites: Header.composites,
    headerSet: Header.headerSet,
    navigationDrawer: Header.navigationDrawer,
    isUserGuest: getIsGuest(state),
    isUserPlcc: isPlccUser(state),
    userName: getUserName(state),
    isRememberedUser: isRememberedUser(state),
    userPoints: getCurrentPointsState(state),
    userRewards: getTotalRewardsState(state),
    isLoggedIn: getUserLoggedInState(state),
    cartItemCount: getCartItemCount(),
    convertedBossUnavailableList: getConvertedBossUnavailableList(state),
    totalItems: BAGPAGE_SELECTORS.getTotalItems(state),
    favStore: state.User && state.User.get('defaultStore'),
    isPickupModalOpen: getIsPickupModalOpen(state),
    isQVModalOpen: getModalState(state),
    isOpenOverlay: getOpenState(state),
    isOpenAddedToBag: isOpenAddedToBag(state),
    isCartItemSFL: getIsCartItemsSFL(state),
    showMiniBag: getIsMiniBagOpen(state),
    trackOrderMountedState: getTrackOrderMountedState(state),
    isDrawerOpen: state.Header.navigationDrawer && state.Header.navigationDrawer.open,
    showFullPageAuth: getEnableFullPageAuth(state),
    isECOM: getECOMStatus(state),
    isRecalculateTaxes: getIsChangeRecalForEcom(state),
    loginModalMountedState: loginModalOpenState(state),
    isCSHEnabled: getIsCSHEnabled(state),
    minibagOnHoverEnabled: getMinibagOnHoverEnabled(state),
    isShowNavAnimation: getIsShowNavAnimation(state),
    isKeepMinibagCloseState: getIsKeepMinibagClose(state),
    isKeepMinibagCloseStateQV: getIsKeepMinibagCloseQV(state),
    userWishListId: selectDefaultWishlistId(state),
    selectWishListCount: selectWishListCount(state),
    defaultWishList: wishListFromState(state),
    activeWishList: selectActiveWishList(state),
    isNewNavigationImagesEnabled: getIsNewNavigationImagesEnabled(state),
    isSearchEnhancementRedesignEnabled: getABTestIsSearchEnhancementRedesignEnabled(state),
    checkNavImagesFlag: getCheckNavImagesFlag(state),
    isExtendedPage,
    router,
    brandId,
    isShopThisStoreEnabled: getIsShopThisStoreEnabled(state),
    accountDrawerOpen: getAccountDrawerOpen(state),
    showShopThisStoreNotification: getShowShopThisStoreNotification(state),
    defaultStore: getDefaultFavStore(state),
    isHamburgerMenuRedesignEnabled: getIsHamburgerMenuRedesignEnabled(state),
    isGuestFavEnabled: getIsGuestFavEnabled(state),
    isConfirmationPageHeaderEnabled: getConfirmationPageHeaderAndButton(state),
    isShowBagSimplifiedHeader: getIsShowBagSimplifiedHeader(state),
    isHeaderScrollViewDisabled: getIsHeaderScrollViewDisabled(state),
    isDrawerTransitionEnabled: getIsDrawerTransitionEnabled(state),
    isStickyHeaderBgColorEnabled: getIsStickyHeaderBgColorEnabled(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
    isSearchBarAlignmentEnabled: getIsSearchBarAlignmentEnabled(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openNavigationDrawer: (id) => {
      dispatch(openNavigationDrawer(id));
    },
    closeNavigationDrawer: () => {
      dispatch(showNavigationFooter());
      dispatch(closeNavigationDrawer());
    },
    openMiniBagDispatch: () => {
      dispatch(openMiniBag());
    },
    closeMiniBagDispatch: () => {
      dispatch(closeMiniBag());
    },
    openOverlay: (component) => dispatch(openOverlayModal(component)),
    closedOverlay: (payload) => {
      dispatch(closeOverlayModal(payload));
    },
    openAccountDrawerDispatch: () => {
      dispatch(openAccountDrawer());
    },
    closeAccountDrawerDispatch: () => {
      dispatch(closeAccountDrawer());
    },
    openTrackOrderOverlay: (payload) => dispatch(setTrackOrderModalMountedState(payload)),
    setClickAnalyticsData: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    onRouteChangeGlobalActions: () => {
      dispatch(closeQuickViewModal({ isModalOpen: false }));
      if (isAndroidWeb() && this?.rootElemId) {
        document.querySelector(`#${this.rootElemId}`).style.display = '';
      }
      dispatch(closePickupModal({ isModalOpen: false }));
      dispatch(setLoginModalMountedState({ state: false, isAccountCardVisible: true }));
    },
    selectOrderAction: () => {
      dispatch(selectOrder({}));
    },
    setLoginModalMountState: (payload) => {
      dispatch(setLoginModalMountedState(payload));
    },
    trackStsClick: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      dispatch(trackClick(payload));
    },
    trackAnalyticsClick: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    mergeAccountReset: () => {
      dispatch(mergeAccountReset());
    },
    resetEmailConfirmationRequest: () => {
      dispatch(resetEmailConfirmationRequest());
    },
    updateMiniBagCloseStatusActn: (payload) => {
      dispatch(updateMiniBagCloseStatus(payload));
    },
    updateMiniBagCloseStatusActnQV: (payload) => {
      dispatch(updateMiniBagCloseStatusQV(payload));
    },
    trackClickAnalyticsBopisFilter: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    setFavData: (payload) => {
      dispatch(setActiveWishlistAction(payload));
    },
    setCondensedState: (payload) => {
      dispatch(setCondensedStatus(payload));
    },
    shopThisStoreNotification: (payload) => {
      dispatch(showShopThisStoreNotifications(payload));
    },
    resetCurrentStoreInfo: () => dispatch(setCurrentStoreInfo(null)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
